import { colors } from 'constants/colors.constant';

// Get client theme from environment variable
const CLIENT_THEME = import.meta.env.VITE_CLIENT_THEME || 'henddu';

// Default color scheme constants (can be overridden by environment)
const DEFAULT_DARK_COLOR = import.meta.env.VITE_DARK_COLOR_SCHEME || 'cinder';
// Options: "cinder", "navy", "mirage", "black", "mint"
const DEFAULT_LIGHT_COLOR = import.meta.env.VITE_LIGHT_COLOR_SCHEME || 'slate';
// Options: "slate", "gray", "neutral"
const DEFAULT_PRIMARY_COLOR = import.meta.env.VITE_PRIMARY_COLOR_SCHEME || 'henddu';
// Options: "indigo", "blue", "green", "amber", "purple", "rose", "henddu", "deepBlue"

// Default theme configuration
export const defaultTheme = {
  themeMode: import.meta.env.VITE_THEME_MODE || 'light',
  // Options: "light", "dark", "system"
  isMonochrome: import.meta.env.VITE_THEME_MONOCHROME === 'true' || false,
  // If true, the theme uses a monochrome color palette
  themeLayout: import.meta.env.VITE_THEME_LAYOUT || 'main-layout',
  // Options: "main-layout", "sideblock"
  cardSkin: import.meta.env.VITE_THEME_CARD_SKIN || 'shadow',
  // Options: "bordered", "shadow"
  
  // Dark mode color scheme
  darkColorScheme: {
    name: DEFAULT_DARK_COLOR,
    ...colors[DEFAULT_DARK_COLOR],
  },
  // Light mode color scheme
  lightColorScheme: {
    name: DEFAULT_LIGHT_COLOR,
    ...colors[DEFAULT_LIGHT_COLOR],
  },
  // Primary color scheme
  primaryColorScheme: {
    name: DEFAULT_PRIMARY_COLOR,
    ...colors[DEFAULT_PRIMARY_COLOR],
  },
  
  // Language settings
  defaultLang: import.meta.env.VITE_DEFAULT_LANGUAGE || 'en',
  fallbackLang: import.meta.env.VITE_FALLBACK_LANGUAGE || 'en',
  direction: import.meta.env.VITE_TEXT_DIRECTION || 'ltr',
  
  // Notification settings
  notification: {
    isExpanded: import.meta.env.VITE_EXPANDED_NOTIFICATIONS === 'true' || false,
    position: import.meta.env.VITE_NOTIFICATION_POSITION || 'top-right',
    visibleToasts: parseInt(import.meta.env.VITE_VISIBLE_TOASTS) || 4,
  },
};

// Export client-specific configuration
export const clientThemeConfig = {
  clientTheme: CLIENT_THEME,
  themeMode: import.meta.env.VITE_THEME_MODE || 'light',
  isMonochrome: import.meta.env.VITE_THEME_MONOCHROME === 'true' || false,
  themeLayout: import.meta.env.VITE_THEME_LAYOUT || 'main-layout',
  cardSkin: import.meta.env.VITE_THEME_CARD_SKIN || 'shadow',
  defaultLang: import.meta.env.VITE_DEFAULT_LANGUAGE || 'en',
  fallbackLang: import.meta.env.VITE_FALLBACK_LANGUAGE || 'en',
  direction: import.meta.env.VITE_TEXT_DIRECTION || 'ltr',
};

// Helper function to get current theme name
export const getCurrentTheme = () => CLIENT_THEME;

// Helper function to check if feature is enabled
export const isFeatureEnabled = (feature) => {
  return clientThemeConfig[feature] || false;
};
